/* EmojiPicker.tsx generated by @compiled/babel-plugin v0.37.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2rkofajl%7Bborder-radius%3Avar(--ds-radius-small%2C3px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._c71l1y6z%7Bmax-height%3Acalc(80vh%20-%2086px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1tke5x59%7Bmin-height%3A340px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ul91edt%7Bmin-width%3A350px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsb1edt%7Bwidth%3A350px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3iixjv%7Bheight%3A375px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._16qs130s%7Bbox-shadow%3Avar(--ds-shadow-overlay%2C0%208px%209pt%20%231e1f2126%2C0%200%201px%20%231e1f214f)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhk1bhr%7Bbackground-color%3Avar(--ds-surface-overlay%2C%23fff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bah1yb4%7Bjustify-content%3Aspace-between%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2lx21bp4%7Bflex-direction%3Acolumn%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1txw%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2rko1mok%7Bborder-radius%3Avar(--ds-radius-large%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._19itahnd%7Bborder%3Avar(--ds-border%2C%230b120e24)%20var(--ds-border-width%2C1px)%20solid%7D");
import React from 'react';
import type { ComponentClass } from 'react';
import { withAnalyticsEvents, type WithAnalyticsEventsProps } from '@atlaskit/analytics-next';
import { ufoExperiences } from '../../util/analytics';
import type { EmojiProvider } from '../../api/EmojiResource';
import type { OnEmojiEvent, PickerSize } from '../../types';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import LoadingEmojiComponent, { type Props as LoadingProps, type State as LoadingState } from '../common/LoadingEmojiComponent';
import type { PickerRefHandler, Props as ComponentProps } from './EmojiPickerComponent';
import { LoadingItem } from './EmojiPickerVirtualItems';
import { UfoErrorBoundary } from '../common/UfoErrorBoundary';
import { defaultEmojiPickerSize } from '../../util/constants';
import { EmojiCommonProvider } from '../../context/EmojiCommonProvider';
const isRefreshEmojiPickerEnabled = (): boolean => {
  if (!FeatureGates.initializeCompleted()) {
    return false;
  }

  // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
  const isEnabled = FeatureGates.getExperimentValue('platform_teamoji_26_refresh_emoji_picker', 'isEnabled', false);
  return isEnabled;
};
const emojiPicker = null;
const emojiPickerNew = null;
const emojiPickerModuleLoader = () => import( /* webpackChunkName:"@atlaskit-internal_emojiPickerComponent" */'./EmojiPickerComponent');
const emojiPickerLoader: () => Promise<React.ComponentType<React.PropsWithChildren<ComponentProps>>> = () => emojiPickerModuleLoader().then(module => module.default);
export const preloadEmojiPicker = (): void => {
  emojiPickerLoader().then(component => {
    EmojiPickerInternal.AsyncLoadedComponent = component;
  });
};
export interface Props extends LoadingProps {
  /**
   * The current Confluence page content id. When provided (and the
   * `confluence_ai_generated_emojis` experiment is on), enables the
   * "Create an emoji with Rovo" AI generation section in the upload flow.
   */
  contentId?: string;
  /**
   * Flag to disable tone selector.
   */
  hideToneSelector?: boolean;
  /**
   * Callback to handle picker reference.
   */
  onPickerRef?: PickerRefHandler;
  /**
   * Callback to be executed on emoji selection.
   */
  onSelection?: OnEmojiEvent;
  /**
   * Size of Emoji Picker. default value is 'medium'.
   */
  size?: PickerSize;
}
export class EmojiPickerInternal extends LoadingEmojiComponent<Props & WithAnalyticsEventsProps, LoadingState> {
  // state initialised with static component to prevent
  // rerender when the module has already been loaded
  static AsyncLoadedComponent?: React.ComponentType<React.PropsWithChildren<ComponentProps>>;
  static defaultProps: {
    size: string;
  } = {
    size: defaultEmojiPickerSize
  };
  state: {
    asyncLoadedComponent: React.ComponentType<React.PropsWithChildren<ComponentProps>> | undefined;
  } = {
    asyncLoadedComponent: EmojiPickerInternal.AsyncLoadedComponent
  };
  constructor(props: Props) {
    super(props, {});
    ufoExperiences['emoji-picker-opened'].start();
  }
  asyncLoadComponent(): void {
    emojiPickerLoader().then(component => {
      EmojiPickerInternal.AsyncLoadedComponent = component;
      this.setAsyncState(component);
    });
  }
  renderLoading(): JSX.Element | null {
    const item = new LoadingItem();
    const handlePickerRef = (ref: any) => {
      if (this.props.onPickerRef) {
        this.props.onPickerRef(ref);
      }
    };
    ufoExperiences['emoji-picker-opened'].markFMP();
    return isRefreshEmojiPickerEnabled() ? <div ref={handlePickerRef} className={ax(["_19itahnd _2rko1mok _1e0c1txw _2lx21bp4 _1bah1yb4 _bfhk1bhr _16qs130s _4t3iixjv _1bsb1edt _1ul91edt _1tke5x59 _c71l1y6z"])}>
				{item.renderItem()}
			</div> : <div ref={handlePickerRef} className={ax(["_19itahnd _2rkofajl _1e0c1txw _2lx21bp4 _1bah1yb4 _bfhk1bhr _16qs130s _4t3iixjv _1bsb1edt _1ul91edt _1tke5x59 _c71l1y6z"])}>
				{item.renderItem()}
			</div>;
  }
  renderLoaded(loadedEmojiProvider: EmojiProvider, EmojiPickerComponent: ComponentClass<ComponentProps>): JSX.Element {
    const {
      emojiProvider,
      ...otherProps
    } = this.props;
    return <UfoErrorBoundary experiences={[ufoExperiences['emoji-picker-opened']]}>
				<EmojiCommonProvider emojiProvider={loadedEmojiProvider}>
					<EmojiPickerComponent {...otherProps} />
				</EmojiCommonProvider>
			</UfoErrorBoundary>;
  }
}
const EmojiPicker: React.ForwardRefExoticComponent<Omit<Props & WithAnalyticsEventsProps, keyof WithAnalyticsEventsProps> & React.RefAttributes<any>> = withAnalyticsEvents()<Props & WithAnalyticsEventsProps, React.ComponentType<Props & WithAnalyticsEventsProps>>((EmojiPickerInternal as any));
export default EmojiPicker;